"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../shared/styles");
var _Text = _interopRequireDefault(require("./Text"));
var _jsxRuntime = require("react/jsx-runtime");
var StatusIndicatorWrapper = _styledComponents.default.div.withConfig({
  displayName: "StatusIndicator__StatusIndicatorWrapper",
  componentId: "sc-106bvwz-0"
})(["display:flex;box-sizing:border-box;align-items:center;gap:", ";border-radius:", ";border:1px solid ", ";padding:", ";"], _styles.spacing.xxs, _styles.spacing.l, function (_ref) {
  var color = _ref.color;
  return _styles.colors[color];
}, _styles.spacing.xxs);
var Indicator = _styledComponents.default.div.withConfig({
  displayName: "StatusIndicator__Indicator",
  componentId: "sc-106bvwz-1"
})(["height:8px;width:8px;background-color:", ";border-radius:50%;display:inline-block;"], function (_ref2) {
  var color = _ref2.color;
  return _styles.colors[color];
});
var statusColorMapping = ['creative', 'warning', 'destructive'];
var statusDescriptionMapping = ['On track', 'At risk', 'Off track'];
var StatusIndicator = function StatusIndicator(_ref3) {
  var status = _ref3.status,
    onClick = _ref3.onClick;
  var color = statusColorMapping[status];
  var description = statusDescriptionMapping[status];
  var clickAndStopPropagation = function clickAndStopPropagation(e) {
    e.stopPropagation();
    onClick();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StatusIndicatorWrapper, {
    color: color,
    onClick: function onClick(e) {
      return clickAndStopPropagation(e);
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Indicator, {
      color: color
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      type: 'label',
      variant: 's',
      color: color,
      children: description
    })]
  });
};
StatusIndicator.defaultProps = {
  status: 0
};
var _default = exports.default = StatusIndicator;